import { render } from "./PurchaseRecordsDialog.vue?vue&type=template&id=b0d50148&scoped=true"
import script from "./PurchaseRecordsDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseRecordsDialog.vue?vue&type=script&lang=js"

import "./PurchaseRecordsDialog.vue?vue&type=style&index=0&id=b0d50148&scoped=true&lang=css"

import exportComponent from "D:\\project2025\\green-lit-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d50148"]])

export default __exports__